import CountUp from "react-countup";
import { motion } from "framer-motion";
import { Reveal, ease } from "../lib/motion";
import { Kicker } from "./MidSections";

const STATS = [
  { end: 75, suffix: "%", d: "of knowledge workers use AI at work." },
  { end: 90, suffix: "%", d: "of AI users say it saves them time." },
  { end: 3, prefix: "", suffix: "×", d: "higher growth in revenue per employee in industries most exposed to AI." },
  { end: 40, suffix: "%", d: "higher productivity growth at companies most exposed to AI." },
];

export default function AIReshaping() {
  return (
    <section className="relative overflow-hidden border-y border-white/5 py-28 md:py-40" data-testid="reshaping-section">
      <div className="absolute left-1/2 top-0 h-[380px] w-[70%] -translate-x-1/2 bg-white/[0.03] blur-[130px]" />
      <div className="relative mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-3xl">
          <Kicker id="reshaping-kicker">The shift</Kicker>
          <Reveal>
            <h2 className="font-display text-4xl font-semibold leading-[1.05] tracking-normal md:text-6xl">
              AI is already reshaping business.
            </h2>
          </Reveal>
        </div>

        <div className="mt-20 grid grid-cols-1 gap-x-10 gap-y-14 sm:grid-cols-2 lg:grid-cols-4">
          {STATS.map((s, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="border-t border-white/10 pt-7" data-testid={`stat-${i}`}>
                <div className="text-metal font-display text-6xl font-semibold tracking-tight md:text-7xl">
                  <CountUp end={s.end} prefix={s.prefix || ""} suffix={s.suffix} enableScrollSpy scrollSpyOnce duration={2.2} />
                </div>
                <p className="mt-5 max-w-[15rem] text-sm leading-relaxed text-[#868d97]">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease }}
          className="mt-24 max-w-4xl"
        >
          <p className="font-display text-2xl font-medium leading-snug text-white md:text-4xl">
            The opportunity is no longer <span className="text-[#868d97]">whether</span> to adopt AI.{" "}
            <br className="hidden md:block" />
            It's <span className="text-metal">how intelligently</span> you implement it.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
